import { render } from "./menuPopup.vue?vue&type=template&id=c2519bda&scoped=true"
import script from "./menuPopup.vue?vue&type=script&lang=js"
export * from "./menuPopup.vue?vue&type=script&lang=js"

import "./menuPopup.vue?vue&type=style&index=0&id=c2519bda&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2519bda"],['__file',"menuPopup.vue"]])

export default __exports__